



const MONEY_DECIMALS = 3

const IndianNumFormat = (number,rupee=false)=>{
    if(number !== null && number !== undefined && number !== ""){
        // console.log("?????????",number)
        const value = Number(number)
        let res = value.toLocaleString('en-IN', {
            minimumFractionDigits: MONEY_DECIMALS,
            maximumFractionDigits: MONEY_DECIMALS,
            style: 'currency',
            currency: 'USD'
        })
        // console.log(res,rupee)
        return  rupee?res:'₹'+res
    }
    return number
}

export default IndianNumFormat
